import { styled } from 'styled-components';

export const Container = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-25);
  border-radius: var(--radius-400);
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }

  &.skin_brand {
    background-color: var(--turquoise-400);
    color: var(--text-standard-primary-subtle);
    border: 1px solid var(--turquoise-500);

    svg path {
      color: var(--text-standard-primary-subtle);
    }

    &.outline {
      border: 1px solid var(--tourquoise-500);
    }

    &:focus:not(:disabled):not(:active).selectable {
      background-color: var(--white);
      border: 1px solid var(--turquoise-400);
      color: var(--turquoise-400);
      svg path {
        color: var(--turquoise-400);
      }
    }

    &:disabled {
      background-color: var(--turquoise-400);
      border-color: var(--turquoise-500);
      color: var(--turquoise-200);
      svg path {
        color: var(--turquoise-200);
      }
    }
  }

  &.skin_default {
    border: 1px solid transparent;
    background: transparent;
    color: var(--text-standard-primary);

    svg path {
      color: var(--text-standard-secondary);
    }

    &.outline {
      border: 1px solid var(--black-600);
    }

    &:hover:not(:disabled) {
      background-color: var(--black-500);
      svg path {
        color: var(--text-standard-primary);
      }
    }

    &:active:not(:disabled) {
      background-color: var(--black-400);
      svg path {
        color: var(--text-standard-primary);
      }
    }

    &:focus:not(:disabled):not(:active).selectable {
      background-color: var(--black-400);
      border-color: var(--turquoise-400);
      svg path {
        color: var(--turquoise-500);
      }
    }

    &:disabled {
      background-color: transparent;
      svg path {
        color: var(--black-600);
      }
    }
  }
`;
